module.exports = __webpack_public_path__ + "static/minsion_bn2@2x-0aa539a88668762d20b918a8f9e1ec66.jpg";